module.exports = __webpack_public_path__ + "0308420cfc964d7770b05ab877de0f2c.png";